import { Component, input, output } from '@angular/core';
import { ButtonComponent, IconComponent } from '@sirius/common';

/** Says which filters were just reset because the visitor switched route, and offers to put them back. */
@Component({
    selector: 'robot-selector-route-notice',
    templateUrl: './route-notice.component.html',
    styleUrl: './route-notice.component.scss',
    imports: [ButtonComponent, IconComponent],
    host: {
        'class': 'route-notice',
        'role': 'status',
    },
})
export class RouteNoticeComponent {
    readonly message = input.required<string>();
    readonly undoLabel = input.required<string>();

    readonly undo = output<void>();
}
